import { render, staticRenderFns } from "./SecurityAdvices.vue?vue&type=template&id=cd5ccc16&scoped=true"
import script from "./SecurityAdvices.vue?vue&type=script&lang=js"
export * from "./SecurityAdvices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5ccc16",
  null
  
)

export default component.exports